<template>
    <section :id="sectionId" v-if="leftText || rightText" class="Cgv">
      <div class="Cgv__wrap">
        <h2 class="Cgv__title raleway-bold-p16">CONDITIONS GÉNÉRALES DE VENTES</h2>
  
        <div class="Cgv__grid">
          <article class="Cgv__col raleway-reg-p15" v-if="leftText" v-html="leftText" />
          <article class="Cgv__col raleway-reg-p15" v-if="rightText" v-html="rightText" />
        </div>
  
        <slot name="footer" />
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'CgvSection',
    props: {
      leftText:  { type: String, default: '' },
      rightText: { type: String, default: '' },
      sectionId: { type: String, default: 'cgv' }
    },
    data() {
      return {
        isPhone: window.innerWidth < 768
      }
    }
  }
  </script>
  
  <style scoped>
  .Cgv { padding: 18px 16px 10px; }
  .Cgv__wrap {
    max-width: 1200px; margin: 0 auto;
    border: 1px solid #e4ebe7; border-radius: 6px;
    background: #fff; padding: clamp(16px, 2.5vw, 24px);
  }
  .Cgv__title {
    text-align: center; margin: 0 0 18px;
    text-transform: uppercase;
    letter-spacing: .02em;
    margin: 0 0 clamp(10px, 1.8vw, 14px);
  }
  .Cgv__grid {
    display: grid; gap: clamp(16px, 2vw, 28px);
    grid-template-columns: 1fr 1fr;
  }
  .Cgv__col :deep(h1), .Cgv__col :deep(h2), .Cgv__col :deep(h3), .Cgv__col :deep(h4) {
    font-weight: 800; font-size: clamp(18px, 2.4vw, 22px); margin: 10px 0 8px;
  }
  .Cgv__col :deep(p), .Cgv__col { line-height: 1.9; color: #0f0f0f; font-size: clamp(14px, 1.9vw, 16px); }
  .Cgv__col :deep(a){ color:#2d5f49; text-decoration: underline; font-weight: 700; }
  
  @media (max-width: 860px){
    .Cgv__grid { grid-template-columns: 1fr; }
  }
  </style>  